<template>
  <button
    :type="type"
    class="centered btn"
    :class="[buttonType, buttonSize]"
    :disabled="disabledComp"
    @click="click"
  >
    <img :src="require('@/assets/loading.svg')" class="loader" v-if="loading" alt="Loading" />
    <slot> {{ text }}</slot>
  </button>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "Btn",
  props: {
    type: {
      type: String,
      default: "button",
    },
    text: String,
    variant: {
      type: String,
      default: "primary",
    },
    size: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const typeList = {
      primary: "btn-primary",
      primaryOutline: "btn-outline-primary",
      secondary: "btn-secondary",
      secondaryOutline: "btn-outline-secondary",
      success: "btn-success",
      successOutline: "btn-outline-success",
      danger: "btn-danger",
      dangerOutline: "btn-outline-danger",
      warning: "btn-warning",
      warningOutline: "btn-outline-warning",
      info: "btn-info",
      infoOutline: "btn-outline-info",
      light: "btn-light",
      lightOutline: "btn-outline-light",
      dark: "btn-dark",
      darkOutline: "btn-outline-dark",
      link: "btn-link",
    };
    const buttonType = computed(() => {
      if (!typeList[props.variant]) {
        return typeList.primaryOutline;
      }

      return typeList[props.variant];
    });
    const sizeList = {
      small: "btn-sm",
      large: "btn-lg",
      block: "btn-block",
    };
    const buttonSize = computed(() => {
      return sizeList[props.size];
    });
    const disabledComp = computed(() => {
      return props.loading || props.disabled;
    });

    const click = (obj) => {
      emit("click", obj);
    };

    return {
      buttonType,
      buttonSize,
      disabledComp,
      click,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.loader {
  width: 1.5em;
  margin-right: 10px;
}

.centered {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
